import React, { FC, Fragment, useState } from 'react';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';

import styles from './UserDropdown.module.scss';
import { menuBasePaperProps } from 'styles';
import { useAuthStatus } from 'auth/useAuthStatus';
import { useAuthUser } from 'auth/useAuthUser';
import { useAuthActions } from 'auth/useAuthActions';


interface UserDropdownProps {}

const UserDropdown: FC<UserDropdownProps> = () => {

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const { initiateSignIn, initiateSignOut } = useAuthActions();
  const { isAuthenticated } = useAuthStatus();
  const { user } = useAuthUser();

  const menuOpen = Boolean(anchorEl);

  const loginHandler = async (): Promise<void> => {
    await initiateSignIn();
  }

  const logoutHandler = async (): Promise<void> => {
    userMenuCloseHandler();
    await initiateSignOut();
  }

  const userMenuClickHandler = (event: React.MouseEvent<HTMLElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  const userMenuCloseHandler = (): void => {
    setAnchorEl(null);
  };

  const userMenu: JSX.Element = (
    <Menu
      anchorEl={anchorEl}
      open={menuOpen}
      onClose={userMenuCloseHandler}
      PaperProps={menuBasePaperProps}
      transformOrigin={{ horizontal: 'center', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
    >
      <div>
        <MenuItem onClick={logoutHandler}>
          Sign Out
        </MenuItem>
      </div>
    </Menu>
  );

  return (
    <div
      className={styles.UserDropdown}
      data-testid="UserDropdown"
    >
      { isAuthenticated &&
        <Fragment>
          <div
            className={styles.userDropdown}
            onClick={userMenuClickHandler}
          >
            <AccountCircleOutlinedIcon fontSize={'large'} />
            <div className={styles.username}>{user?.profile.name || 'Anonymous'}</div>
          </div>

          {userMenu}
        </Fragment>
      }

      { !isAuthenticated &&
        <Fragment>
          <div
            className={styles.userDropdown}
            onClick={loginHandler}
          >
            <AccountCircleOutlinedIcon fontSize={'large'} />
            <div className={styles.username}>Sign in</div>
          </div>
        </Fragment>
      }
    </div>
  );
}

export default UserDropdown;
